import { render, staticRenderFns } from "./divinity.vue?vue&type=template&id=793cd444&scoped=true&"
import script from "./divinity.vue?vue&type=script&lang=js&"
export * from "./divinity.vue?vue&type=script&lang=js&"
import style0 from "./divinity.vue?vue&type=style&index=0&id=793cd444&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793cd444",
  null
  
)

export default component.exports